const chunkMapping = {
	"119": [
		70119
	],
	"144": [
		5144
	],
	"158": [
		45158
	],
	"640": [
		86640
	],
	"710": [
		88710
	],
	"905": [
		79905
	]
};
const idToExternalAndNameMapping = {
	"5144": [
		"default",
		"./Favorites",
		37786
	],
	"45158": [
		"default",
		"./docHubReducer",
		37786
	],
	"70119": [
		"default",
		"./Dashboard",
		37786
	],
	"79905": [
		"default",
		"./FilePreviewDialog",
		37786
	],
	"86640": [
		"default",
		"./AppLayout",
		37786
	],
	"88710": [
		"default",
		"./FolderView",
		37786
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}